import React from "react";
import clsx from "clsx";
import { Chip } from "@mui/material";
import { makeStyles } from "@/compat/muiStyles";
import { green, grey, red } from "@mui/material/colors";

const useStyles = makeStyles(() => ({
  root: {
    color: "white",
    borderRadius: "4px",
    "&.status-0": {
      backgroundColor: grey[400],
    },
    "&.status-1": {
      backgroundColor: red[400],
    },
    "&.status-2": {
      backgroundColor: green[400],
    },
  },
}));

function StatusChip({ status, statusName }) {
  const classes = useStyles();

  if (status === null || statusName === null) return null;

  return (
    <Chip
      size="small"
      className={clsx(classes.root, `status-${status}`)}
      label={statusName}
    />
  );
}

export default StatusChip;
